import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app.module';
import {Config} from './config';

//import 'whatwg-fetch';


// // This is to use Fetch API (NOT working in IE or mobile browsers but can use polyfill) 
// window.fetch('data/settings.json', {method: 'get'}).then((response) => {
//     response.json().then((config:Object) => {
//         Config.config = config;
//         platformBrowserDynamic().bootstrapModule(AppModule)
//     });
// });


// // This is to use the XMLHttpRequest API (good but might be some hickups with browsers)
// var xhr = new XMLHttpRequest;
// xhr.onreadystatechange = function() {
//     if (xhr.readyState == 4 && xhr.status == 200) {
//          Config.config = JSON.parse(xhr.responseText);
//          platformBrowserDynamic().bootstrapModule(AppModule);
//     }
// }
// xhr.open("GET", 'data/settings.json')
// xhr.send();


// This is to use dojo/request/xhr from ArcGIS JS API library (theoretically compatible with all browsers)
define(["dojo/request/xhr"], function(xhr){
    xhr("data/settings.json", {
        handleAs: "json"
    }).then(function(data){
        // Do something with the handled data
        Config.config = data;
        platformBrowserDynamic().bootstrapModule(AppModule);
    }, function(err){
        // Handle the error condition
        console.log(err);
    }, function(evt){
        // Handle a progress event from the request if the
        // browser supports XHR2
    });
});


// WEBPACK FOOTER //
// ./app/main.ts